import { createPortal } from "react-dom";

export default function VideoModal({ isOpen, videoId, onClose }) {
  if (!isOpen) return null;

  return createPortal(
    <div className="video-overlay-container" style={{ display: "flex" }}>
      <div id="video-overlay">
        <div className="video-container">
          <iframe
            title="video"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>
        <span id="video-close" onClick={onClose}>
          Close
        </span>
      </div>
    </div>,
    document.getElementById("modal-video-container")
  );
}
